import React, { useMemo } from 'react';
import { Text, Flex } from '@instructure/ui';
import { getStore, usePlayerStore } from '../../../../stores/StoreContext';

const AnnotationLabels = () => {
  const PlayerStore = getStore('playerStore');
  const displayMarkers = usePlayerStore((state) => state.displayMarkers);
  const markersDisplayProperties = usePlayerStore((state) => state.markersDisplayProperties);

  const labels = useMemo(() => {
    return PlayerStore.markers
      .filter((marker) => displayMarkers.includes(marker.id))
      .map((marker) => (
        <Flex.Item
          key={`marker_label_${marker.id}`}
          as="div"
          padding="none none none x-small"
          width="100%"
          height={`${markersDisplayProperties[marker.id].height}px`}
          textAlign="start"
        >
          <Text size="small">{marker.label}</Text>
        </Flex.Item>
      ));
  }, [displayMarkers, PlayerStore.markers, markersDisplayProperties]);

  return <>{labels}</>;
};

export default AnnotationLabels;
